import {SET_ACTUAL_PROJECT, INITIALIZE_PROJECT,ActionsProject} from "~/actions/scenario.action";
  
const initialScenario = {
  scenario: null,
};

const scenarioReducer = (state = initialScenario, action:ActionsProject) => {
  switch (action.type) {
  case SET_ACTUAL_PROJECT:
    // console.log('actual project', action.payload);
    return {
      ...state,
      scenario: action.payload,
    };
  case INITIALIZE_PROJECT:
    return {
      ...state,
      scenario: null,
    };

  default:
    return state;
  }
};

export default scenarioReducer
